<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <kiosk-ten-dlc-checkbox-filter
            label="Source"
            name="source"
            :options="sourceOptions"
            v-model="source"
        ></kiosk-ten-dlc-checkbox-filter>

        <kiosk-ten-dlc-checkbox-filter
            label="Verification"
            name="verified"
            :options="verificationOptions"
            v-model="verified"
        ></kiosk-ten-dlc-checkbox-filter>

        <kiosk-ten-dlc-checkbox-filter
            label="Vetting"
            name="vetting"
            :options="vettingStateOptions"
            v-model="vettingStates"
        ></kiosk-ten-dlc-checkbox-filter>

        <kiosk-ten-dlc-checkbox-filter
            label="Trust Score"
            name="bucket"
            :options="scoreBucketOptions"
            v-model="scoreBuckets"
        ></kiosk-ten-dlc-checkbox-filter>

        <kiosk-ten-dlc-checkbox-filter
            label="Campaigns"
            name="has-campaigns"
            :options="campaignsOptions"
            v-model="hasCampaigns"
        ></kiosk-ten-dlc-checkbox-filter>

        <kiosk-ten-dlc-checkbox-filter
            label="Numbers"
            name="has-phone-numbers"
            :options="phoneNumbersOptions"
            v-model="hasPhoneNumbers"
        ></kiosk-ten-dlc-checkbox-filter>
    </div>
</template>

<script lang="ts" setup>
import { listSelection, scalarSelection } from '~/components/kiosk/kiosk-ten-dlc/filterSelection';
import KioskTenDlcCheckboxFilter from '~/components/kiosk/kiosk-ten-dlc/list/KioskTenDlcCheckboxFilter.vue';
import { scoreBucketOptions, sourceLabels, vettingStateOptions } from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrListParams } from '~/services/adminTenDlcClient.types';

const sourceOptions: { label: string; value: NonNullable<TcrListParams['source']> }[] = [
    { label: sourceLabels.tcr, value: 'tcr' },
    { label: sourceLabels.twilio, value: 'twilio' },
];

// 1/0 because qs serialises false as the string "false", which Laravel's boolean rule rejects.
const verificationOptions: { label: string; value: NonNullable<TcrListParams['verified']> }[] = [
    { label: 'Verified', value: 1 },
    { label: 'Unverified', value: 0 },
];

const campaignsOptions: { label: string; value: NonNullable<TcrListParams['has_campaigns']> }[] = [
    { label: 'Has campaigns', value: 1 },
    { label: 'No campaigns', value: 0 },
];

const phoneNumbersOptions: { label: string; value: NonNullable<TcrListParams['has_phone_numbers']> }[] = [
    { label: 'Has numbers', value: 1 },
    { label: 'No numbers', value: 0 },
];

const filters = defineModel<TcrListParams>({ default: () => ({}) });

const source = scalarSelection(
    () => filters.value.source,
    (value) => {
        filters.value.source = value;
    }
);

const verified = scalarSelection(
    () => filters.value.verified,
    (value) => {
        filters.value.verified = value;
    }
);

const hasCampaigns = scalarSelection(
    () => filters.value.has_campaigns,
    (value) => {
        filters.value.has_campaigns = value;
    }
);

const hasPhoneNumbers = scalarSelection(
    () => filters.value.has_phone_numbers,
    (value) => {
        filters.value.has_phone_numbers = value;
    }
);

const vettingStates = listSelection(
    () => filters.value.vetting_states,
    (values) => {
        filters.value.vetting_states = values;
    }
);

const scoreBuckets = listSelection(
    () => filters.value.vetting_score_buckets,
    (values) => {
        filters.value.vetting_score_buckets = values;
    }
);
</script>
